import { createFileRoute } from '@tanstack/react-router'
import { CostCategoriesSection } from '../../../features/projects/cost-categories-section'
import { requireSection } from '../../../features/settings/guards'

export const Route = createFileRoute('/_app/settings/project-cost-categories')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'project-cost-categories'),
  component: CostCategoriesSection,
})
